import { useContext, useEffect, useState } from "react"
import { UseCasesContext } from "../../../../context/useCases"
import { useTypedSelector } from "../../../../hooks/useTypedSelector"
import { Link, useParams } from "react-router-dom"
import { Menu } from "../../../components/menu"
import { UploadTaskYear } from "../../../../repository/api/generated"
import { Edit } from "tabler-icons-react"
import { ImageItem } from "./image-item"

export const UploadMonthsList = () => {
    const MAX_PHOTO_SIZE = 4

    let { id } = useParams();


    const [tree, setTree] = useState<UploadTaskYear[]>([])

    const [year, setYear] = useState(-1)

    const [yearList, setYearList] = useState<number[]>([])

    const [monthsList, setMonthsList] = useState<number[]>([])

    const [month, setMonth] = useState(-1)

    const [images, setMonthsImages] = useState<string[]>([])

    const [files, setFiles] = useState<File[]>([]);

    const [loading, setLoading] = useState(true)

    const [showModal, setShowModal] = useState(false)


    let useCases = useContext(UseCasesContext)

    const landings = useTypedSelector(({ landing }) => {
        return landing
    })

    const readTree = async () => {
        let response = await useCases?.uploadtaskUseCase.ReadDirsTreeOfSite(id!)
        if (response instanceof Error) {

        } else {
            setTree([...response!])
        }
    }

    let monthNames = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"]

    const getMonthName = (index: number) => {
        
        return monthNames[index - 1];
    }


    useEffect(() => {
        readTree()
    }, [])

    useEffect(() => {
        if (tree) {
            let sortedTree = tree.sort((a, b) => b.value! - a.value!).map((year) => {
                return year.value!;
            })
            setYearList(sortedTree)
            setYear(sortedTree[0])
        }
    }, [tree])

    useEffect(() => {
        if (tree && tree.find(x => x.value === year)) {
            setMonthsList([])
            setMonth(-1)
            let monthsList = tree.find(x => x.value === year)!.months!.sort((a, b) => b! - a!)
            setMonthsList(monthsList)
            setMonth(monthsList[0])
        }
    }, [year])

    const readImages = async () => {
        let response = await useCases?.uploadtaskUseCase.ReadMonthsImagesOfSite(id!, year, month)
        if (response instanceof Error) {

        } else {
            setMonthsImages([...response!])
        }
    }

    useEffect(() => {
        readFilesOfMonth()
    }, [month])

    const readFilesOfMonth = async () => {
        setLoading(true)
        setFiles([])
        let response = await useCases?.uploadtaskUseCase.ReadMonthsImagesOfSite(id!, year!, month!)
        if (response instanceof Error) {

        } else {
            let filesList: { name: string, file: File }[] = []
            await Promise.all(response!.map(async (file) => {
                filesList.push({ name: file, file: (await readFile(file))! })
            }))

            let files: File[] = []

            filesList.sort((a, b) => a.name.localeCompare(b.name))
            filesList.map((file) => {
                files.push(file!.file)
            })

            setFiles(files)
        }
        setLoading(false)
    }


    const readFile = async (fileName: string) => {
        let file = await useCases?.uploadtaskUseCase.ReadImageFromUrl(id!, year.toString(), month.toString(), fileName)
        return file
    }

    return (
        <div className="layout-page" >
            <Menu />
            <div className="content-wrapper" >
                <div className="container-xxl flex-grow-1 container-p-y">
                    <div className="row mx-1">
                        <div className="col-sm-12 col-md-4">
                            <h4 className="fw-bold py-3 mb-4"><span className="text-muted fw-light">Загрузка фото /</span> Структура папок</h4>
                        </div>

                        <div className="col-sm-12 col-md-8">
                            <div className="dt-action-buttons text-xl-end text-lg-start text-md-end text-start d-flex align-items-center justify-content-md-end justify-content-center flex-wrap me-1">
                                <div className="dt-buttons py-3 mb-4">
                                    <Link to={"/landing/add"} className="dt-button add-new btn btn-primary mb-3 mb-md-0" onClick={(e)=>{e.preventDefault(); setShowModal(true)}} ><span>Добавить месяц</span></Link>
                                </div>
                            </div>
                        </div>

                        <div className="card-body">
                            <div className="row">
                                <div className="mt-3">
                                    <div className="text-light small fw-semibold" style={{ marginBottom: "10px" }}>Год</div>
                                    <div className="btn-group" role="group" aria-label="Basic example">
                                        {yearList.map((yearItem) => {
                                            return <button type="button" onClick={() => { setYear(yearItem) }} className={year == yearItem ? "btn btn-label-primary waves-effect" : "btn btn-label-secondary waves-effect"}>{yearItem}</button>
                                        })}
                                    </div>
                                </div>
                            </div>

                            {monthsList.length > 0 ? <div className="row">
                                <div className="mt-3">
                                    <div className="text-light small fw-semibold" style={{ marginBottom: "10px" }}>Месяц</div>
                                    <div className="btn-group" role="group" aria-label="Basic example">
                                        {monthsList.map((monthItem) => {
                                            return <button type="button" onClick={() => { setMonth(monthItem) }} className={monthItem == month ? "btn btn-label-primary waves-effect" : "btn btn-label-secondary waves-effect"}>{getMonthName(monthItem)}</button>
                                        })}
                                    </div>
                                </div>
                            </div> : <></>}

                            {files && !loading ? <div className="row">
                                <div className="mt-3">
                                    <div className="text-light small fw-semibold" style={{ marginBottom: "10px" }}>Фото</div>
                                    <div className="row mb-5" role="group" aria-label="Basic example">
                                        {files.map((file, index) => {
                                            if (index + 1 > MAX_PHOTO_SIZE) {
                                                return
                                            }

                                            return <div className="col-md-4 col-xl-2">
                                                <div className="card bg-dark border-0 text-white">
                                                    <ImageItem file={file} />
                                                </div>
                                            </div>
                                        })}

                                        {<div className="col-md-4 col-xl-2" style={{ display: "flex", alignItems: "center" }}>
                                            <div className="card bg-secondary text-white mb-3">
                                                <div className="card-body" style={{ width: "100%", height: "100%" }}>
                                                    {files.length - MAX_PHOTO_SIZE > 0 ? <h5 className="card-title text-white">... и еще {files.length - MAX_PHOTO_SIZE} фото</h5> : <></>}
                                                    <Link to={"/upload/" + id + "/" + year + "/" + month} style={{ display: "flex", textAlign: "center" }}><Edit /> редактировать<br /> месяц</Link>
                                                </div>
                                            </div>
                                        </div>}
                                    </div>
                                </div>
                            </div> : <div className="row">
                                <div className="mt-3">
                                    <h4 className="fw-bold py-3 mb-4"><span className="text-muted fw-light">Загрузка...  </span></h4>
                                </div>
                            </div>}

                        </div>

                    </div>
                </div>
            </div>
            {
                showModal?<div className="modal fade show" id="basicModal" style={{ "display": "block" }} aria-modal="true" role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel1">Добавление месяца</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={(e)=>{e.preventDefault(); setShowModal(false)}}></button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col mb-3">
                                        <label htmlFor="nameBasic" className="form-label">Год</label>
                                        <select className="form-select" value={year} onChange={(e)=>{ setYear(parseInt(e.target.value))}}>
                                            {[new Date().getFullYear() - 1, new Date().getFullYear(), new Date().getFullYear() + 1,].map((year, index)=>{
                                                return <option value={year}>{year}</option>
                                            })}
                                        </select>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col mb-3">
                                        <label htmlFor="nameBasic" className="form-label">Месяц</label>
                                        <select className="form-select" value={month} onChange={(e)=>{ setMonth(parseInt(e.target.value))}}>
                                            {monthNames.map((month, index)=>{
                                                return <option value={index + 1}>{month}</option>
                                            })}
                                        </select>
                                    </div>
                                </div>

                            </div>
                            <div className="modal-footer">
                                <Link className="btn btn-primary waves-effect waves-light" to={"/upload/" + id + "/" + year + "/" + month} style={{ display: "flex", textAlign: "center" }}>
                                    Создать
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>:<></>
            }
        </div>

    )

}